import {Fragment, useState} from 'react';
import {Listbox, Transition} from '@headlessui/react';
import {CheckIcon, ChevronDownIcon} from '@heroicons/react/20/solid';
import {Text} from '../elements';
import { useFilterUI } from '../product';
import {useCallback} from 'react';

const sortOptions = [
  {
    code: 'BEST_SELLING',
    name: 'Best selling',
  },
  {
    code: 'TITLE',
    name: 'Alphabetically, A-Z',
  },
  {
    code: 'TITLE',
    reverse: true,
    name: 'Alphabetically, Z-A',
  },
  {
    code: 'PRICE',
    name: 'Price, low to high',
  },
  {
    code: 'PRICE_REVERSE',
    name: 'Price, high to low',
  }
];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}
export function Sort({className}) {
  return;
  const {sortKey, updateSortKey} = useFilterUI();
  const handleChangeSortKey = useCallback((option) => (updateSortKey(option.code)), [updateSortKey]);
  
  return (
    <span className={className}>
      <Listbox value={sortOptions.find(option => option.code === sortKey)?.name} onChange={handleChangeSortKey}>
        {({open}) => (
          <>
            <div className="w-full mx-2 mr-4">
              <Listbox.Button className="relative w-full bg-slate-200/30 flex items-center cursor-default rounded border border-gray-300 py-1.5 pl-3 pr-10 text-left shadow-sm focus:border-brand focus:outline-none focus:ring-1 focus:ring-brand sm:text-sm">
                <Text as="span" color="subtle" size="fine">
                  Sort By :
                </Text>
                <span className="flex px-0.5 font-semibold items-center">
                  <Text as="span" color="primary" size="sort">
                    {sortOptions.find(option => option.code === sortKey)?.name}
                  </Text>
                </span>
                <span className="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
                  <ChevronDownIcon
                    className="h-5 w-5 text-brand"
                    aria-hidden="true"
                 />
                </span>
              </Listbox.Button>
              <Transition
                show={open}
                as={Fragment}
                leave="transition ease-in duration-100"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Listbox.Options className="sm:absolute z-40 mt-1 max-h-56 lg:w-60 w-[17.5rem] p-1 overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                  {sortOptions.map((sortOption, index) => (
                    <Listbox.Option
                      key={index}
                      className={({active}) =>
                        classNames(
                          active
                            ? 'text-white bg-brand'
                            : 'text-gray-900',
                          'relative rounded-md cursor-default select-none py-2 pl-3 pr-9',
                        )
                      }
                      value={sortOption}
                    >
                      {({selected, active}) => (
                        <>
                          <div className="flex items-center">
                            <span
                              className={classNames(
                                selected ? 'font-semibold' : 'font-normal',
                                'ml-3 block truncate',
                              )}
                            >
                              <Text
                                as="p"
                                color="primary hover:contrast"
                                size="copy"
                              >
                                {sortOption.name}
                              </Text>
                            </span>
                          </div>

                          {selected ? (
                            <span
                              className={classNames(
                                active ? 'text-white' : 'text-brand',
                                'absolute inset-y-0 right-0 flex items-center pr-4',
                              )}
                            >
                              <CheckIcon className="h-5 w-5" aria-hidden="true"/>
                            </span>
                          ) : null}
                        </>
                      )}
                    </Listbox.Option>
                  ))}
                </Listbox.Options>
              </Transition>
            </div>
          </>
        )}
      </Listbox>
    </span>
  );
}
